import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { agregarAlerta } from "../../../../actions/empadronamiento/Empadronamiento"; // Acción para guardar la fecha
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
export const ModalAgregarAlerta = (props) => {
  const dispatch = useDispatch();
  const [mensaje, setMensaje] = useState(props.alertas ? props.alertas.mensaje : "");
    const [fechaAlerta, setFechaAlerta] = useState(props.alertas ? props.alertas.fechaAlerta : new Date());

  const onSubmitHandler = (e) => {
    e.preventDefault();

    dispatch(agregarAlerta(props.alertas?.idAlertas,props.idSolicitud, fechaAlerta,mensaje,props.close));
  };
  
  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <Typography>Debe ingresar una fecha para crear la alerta que será enviada al afiliado.</Typography>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2} style={{ margin: "2rem 3" }}>
            <Grid item xs={12} sm={12} style={{margin:'0 auto'}}>
              <Grid container spacing={2} style={{ margin: "2rem 3" }}>
                <Grid item xs={12} style={{marginTop:'1rem'}}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    multiline
                    label="Mensaje"
                    name="mensaje"
                    value={mensaje}
                    onChange={(e) => setMensaje(e.target.value)}
                    validators={["required"]}
                    errorMessages={["Este campo es requerido"]}
                  />
                </Grid>
              </Grid>
              <Grid item xs={6} style={{display:'flex', margin:'0 auto'}}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  margin="normal"
                  id="fechaAlerta"
                  label="Fecha de Alerta"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  fullWidth
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={false}
                  value={fechaAlerta}
                  onChange={(date) => {
                    setFechaAlerta(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                  minDate={new Date()}
                  minDateMessage="La fecha no puede ser anterior a la fecha actual"
                />
              </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Grid>

          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            {fechaAlerta && (
              <Button type="submit" variant="contained" disabled={props.disabled} color="primary">
                Aceptar
              </Button>
            )}
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
